// generated from 135 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const contextVariableFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("context_variable_filter"),
  comparison_key: z.string().regex(/^\d+-\d+$/), // Matches "1-1", "2-3", etc.
  display_name: z.string(),
  // undefined: 44 (32.59%), defined 91 (67.41%)
  raw_value: z
    .object({
      // null: 70 (76.92%)
      personalization_type: z
        .enum([
          "custom_attribute", // 7 (33.33%)
          "custom_attributes", // 7 (33.33%)
          "context", // 7 (33.33%)
        ])
        .nullable(),
      variable_name: z.string().nullable(),
      variable_value: z.union([
        z.null(),
        // boolean samples: 11 (12.09%)
        // true 10 (90.91%), false 1 (9.09%)
        z.boolean(),
        // number samples: 20 (21.98%)
        z.number(),
        // string samples: 58 (63.74%)
        z.string(),
        // array samples: 2 (2.20%)
        z.array(z.string()),
      ]),
    })
    .optional(),
  value: z.object({
    // null: 111 (82.22%)
    personalization_type: z
      .enum([
        "context", // 9 (37.50%)
        "custom_attribute", // 8 (33.33%)
        "custom_attributes", // 7 (29.17%)
      ])
      .nullable(),
    // null: 3 (2.22%)
    variable_name: z.string().nullable(),
    variable_value: z.union([
      // null samples: 3 (2.22%)
      z.null(),
      // boolean samples: 32 (23.70%)
      // true 31 (96.88%), false 1 (3.13%)
      z.boolean(),
      // number samples: 32 (23.70%)
      // avg: 1892047.78, min: 0, max: 10141536
      z.number(),
      // string samples: 65 (48.15%)
      z.string(),
      // array samples: 3 (2.22%)
      z.array(z.string()),
    ]),
  }),
  varies_by_app_group: z.literal(false),
});
